import Request from './request'

const Utilities = {
  getUtilities (callback) {
    Request.get('utility/get-actions').then(callback).catch(this.bad_answer)
  },
}
export default Utilities
